// extracted by mini-css-extract-plugin
export default {"overlay":"GB-z","bodyOpen":"HB-z","content":"IB-z","header":"JB-z","close":"KB-z","closeNoHeading":"LB-z"};